// @flow
import React from "react";
import { withTranslation } from "react-i18next";

const NotFound = props => <span>{props.t("NotFound.subtitle")}</span>;

export default withTranslation(["common"])(NotFound);
